import React__default, { useState, useMemo } from 'react';

const IsOTPSendedContext = React__default.createContext([false, () => null]);
const IsOTPSendedProvider = ({ children }) => {
    const [state, setState] = useState(false);
    const value = useMemo(() => [state, setState], [state, setState]);
    return React__default.createElement(IsOTPSendedContext.Provider, { value: value }, children);
};

export { IsOTPSendedContext, IsOTPSendedProvider };
//# sourceMappingURL=provider.js.map
